export default __webpack_public_path__ + "static/media/info.f5aed65a.svg";